export enum SourceType {
  manual = "MANUAL_ENTRY",
  device = "DEVICE",
}
